__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "subscribed-services-uimfe";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bsd/observability", "2.5.14", function() { return __webpack_require__.e(229).then(function() { return function() { return __webpack_require__(6229); }; }); });
			register("@bsd/ui-utils", "2.2.1", function() { return Promise.all([__webpack_require__.e(469), __webpack_require__.e(318), __webpack_require__.e(701)]).then(function() { return function() { return __webpack_require__(6469); }; }); });
			register("bxt-design-framework", "1.0.75", function() { return Promise.all([__webpack_require__.e(231), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(472), __webpack_require__.e(848)]).then(function() { return function() { return __webpack_require__(3231); }; }); });
			register("classnames", "2.2.6", function() { return __webpack_require__.e(485).then(function() { return function() { return __webpack_require__(2485); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(function() { return function() { return __webpack_require__(961); }; }); });
			register("react-router-dom", "6.30.2", function() { return Promise.all([__webpack_require__.e(648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(function() { return function() { return __webpack_require__(2648); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(540).then(function() { return function() { return __webpack_require__(6540); }; }); });
			initExternal(2110);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};